// 基础类型定义
export type TrackEvent = {
  nodeType: 'inputStay' | 'fieldError' | 'click' | 'api' | 'errorModal' |string;//事件类型
  nodeName?: string;//节点名称
  nodeDesc?: string;//节点描述(如按钮内容)
  fieldKey?: string;//表单控件字段key
  fieldLabel?: string;//表单控件字段描述
  fieldVal?: string;//表单控件字段输入值
  fieldError?: string;//表单控件字段错误信息
  url?: string;//api请求url
  httpStatus?: number;//api请求状态码
  success?: boolean;//api请求业务成功与否
  errorMsg?: string;//api请求业务错误信息
  errorCode?: string;//api请求业务错误码
  formData?: any;//api请求入参数据
  duration?: number;//耗时，单位毫秒(如控件输入停留时间，接口请求时间)
  ext?: any;//自定义扩展数据
  timestamp: number;//当前记录时间戳
  href?: string;//当前页面完整的链接，可能带参数
};

export interface EventListener {
  start(onEmit: (event: TrackEvent,el?: HTMLElement) => void,container:HTMLElement,trackerBaseData?:any): void;
  stop(): void;
}

// 抽象基类
abstract class BaseListener implements EventListener {
  protected config: {
    onEmit: (event: TrackEvent,el?: HTMLElement) => void,
    container: HTMLElement
  };

  constructor() {
    this.config = {
      onEmit: () => { },
      container: document.body
    };
  }
  abstract start(onEmit: (event: TrackEvent,el?: HTMLElement) => void,container:HTMLElement): void;
  abstract stop(): void;
}

export default BaseListener;
